export enum OsasQuestionnaireName {
    ess = 'ess',
    fosq10 = 'fosq-10',
    hsdq = 'hsdq',
}
